import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router'

const ItemProject = props => (
  <tr key={props.indexKey}>
    <td> { parseInt(props.skip, 0) + props.indexKey + 1} </td>
    <td> {moment(props.project.createdAt).format('MMMM Do YYYY')} </td>
    <td> {moment(props.project.updatedAt).format('MMMM Do YYYY')} </td>
    <td>
      <span>
        <Link to={`/projects/${props.project.id}`} >
          {props.project.name}
        </Link>
      </span>
    </td>
    <td> <span>{props.orderStatus[props.project.status]}</span> </td>
  </tr>
)

ItemProject.propTypes = {
  indexKey: PropTypes.number.isRequired,
  skip: PropTypes.number.isRequired,
  project: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  orderStatus: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default ItemProject
